import type { ICellRendererParams } from 'ag-grid-community';
import type { ForecastRun } from '../../schema';

function formatDuration(seconds: number | null): string {
  if (seconds == null) return '—';
  if (seconds < 60) return `${seconds}s`;
  const min = Math.floor(seconds / 60);
  const sec = seconds % 60;
  if (min < 60) return sec === 0 ? `${min}m` : `${min}m ${sec}s`;
  const hr = Math.floor(min / 60);
  const remMin = min % 60;
  return remMin === 0 ? `${hr}h` : `${hr}h ${remMin}m`;
}

export function DurationCell(p: ICellRendererParams<ForecastRun>) {
  if (!p.data) return null;
  const isRunning = p.data.status === 'running';
  if (isRunning) {
    return (
      <span className="text-[12px] italic text-foreground-muted">in progress…</span>
    );
  }
  return (
    <span className="text-[13px] tabular-nums text-foreground">
      {formatDuration(p.data.durationSeconds)}
    </span>
  );
}
